import {Module} from '@dms/api/shared';
import {moduleKeys} from '@dms/config';
import {rentalOrderRoutes} from '@dms/routes';
import {permissions} from '@dms/shared';

import {RentalOrderDetail} from './pages/RentalOrderDetail/RentalOrderDetail';
import {RentalOrderOverview} from './pages/RentalOrderOverview/RentalOrderOverview';

export const RentalOrderModule: Module = {
  id: moduleKeys.rentalOrder,
  alwaysShowContent: true,
  layoutProps: {
    title: 'module.rentalOrder.title',
    icon: 'sidebar/rental-order',
  },
  routerProps: {
    path: rentalOrderRoutes.overview,
    element: <RentalOrderOverview />,
  },
  requiredPermission: [permissions.readRentalOrder, permissions.readRentalVehicle],
  content: [
    {
      id: 'rental-order-overview',
      routerProps: {
        path: rentalOrderRoutes.overview,
        element: <RentalOrderOverview />,
      },
      layoutProps: {
        title: 'page.rentalOrder.labels.overview',
        icon: 'sidebar/rental-order',
      },
    },
    {
      id: 'rental-order-overview-kanban',
      routerProps: {
        path: rentalOrderRoutes.overviewKanban,
        element: <RentalOrderOverview />,
      },
    },
    {
      id: 'rental-order-overview-calendar',
      routerProps: {
        path: rentalOrderRoutes.overviewCalendar,
        element: <RentalOrderOverview />,
      },
    },
    {
      id: 'rental-order-vehicleAndCustomer',
      routerProps: {
        path: rentalOrderRoutes.vehicleAndCustomer,
        element: <RentalOrderDetail />,
      },
    },
    {
      id: 'rental-order-create',
      routerProps: {
        path: rentalOrderRoutes.create,
        element: <RentalOrderDetail />,
      },
    },
    {
      id: 'rental-order-rentVehicleInspections',
      routerProps: {
        path: rentalOrderRoutes.rentVehicleInspections,
        element: <RentalOrderDetail />,
      },
    },
    {
      id: 'rental-order-returnVehicleInspections',
      routerProps: {
        path: rentalOrderRoutes.returnVehicleInspections,
        element: <RentalOrderDetail />,
      },
    },
    {
      id: 'rental-order-returnVehicle',
      routerProps: {
        path: rentalOrderRoutes.returnVehicle,
        element: <RentalOrderDetail />,
      },
    },
    {
      id: 'rental-order-rentVehicle',
      routerProps: {
        path: rentalOrderRoutes.rentVehicle,
        element: <RentalOrderDetail />,
      },
    },
    {
      id: 'rental-order-rentVehicleInspections',
      routerProps: {
        path: rentalOrderRoutes.rentVehicleInspections,
        element: <RentalOrderDetail />,
      },
    },
    {
      id: 'rental-order-create',
      routerProps: {
        path: rentalOrderRoutes.create,
        element: <RentalOrderDetail />,
      },
      requiredPermission: permissions.readRentalOrder,
      layoutProps: {
        title: 'page.rentalOrder.labels.create',
        isPartOfCreateMenuItem: true,
      },
    },
    {
      id: 'rental-order-documents',
      routerProps: {
        path: rentalOrderRoutes.documents,
        element: <RentalOrderDetail />,
      },
    },
    {
      id: 'rental-order-activityLogs',
      routerProps: {
        path: rentalOrderRoutes.activityLogs,
        element: <RentalOrderDetail />,
      },
    },
    {
      id: 'rental-order-emailActivityLogs',
      routerProps: {
        path: rentalOrderRoutes.emailActivityLogs,
        element: <RentalOrderDetail />,
      },
    },
    {
      id: 'rental-order-photos',
      routerProps: {
        path: rentalOrderRoutes.photos,
        element: <RentalOrderDetail />,
      },
    },
    {
      id: 'rental-order-serviceOrder',
      routerProps: {
        path: rentalOrderRoutes.serviceOrder,
        element: <RentalOrderDetail />,
      },
    },
  ],
};
